import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    sales: {
        [theme.breakpoints.between('sm', 'lg')]: {
            
            justifyContent: 'space-evenly'
        }
    },
    root: {
        display: 'flex',
        justifyContent: 'space-evenly',
        [theme.breakpoints.between('xs', 'sm')]: {
            flexWrap: 'wrap',
        },
        flexGrow: 1,
    },
    root_rds: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignContent: 'center',
        margin: '50px',
        overflow: 'auto'
    },
    table: {
        padding: '50px',
    },
    card: {
        backgroundColor: '#c7c7c3c3',
        border: '2px solid #2d92d8',
        display: 'flex',
        minWidth: 200,
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '10px'
        },
    },
    billedCard: {
        marginTop: '17%'
    },
    graphCard: {
        backgroundColor: '#000',
        border: '2px solid #2d92d8',
        display: 'flex',
        minWidth: 200,
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '10px'
        },
    },
    content: {
        padding: '50px',
        [theme.breakpoints.between('xs', 'sm')]: {
            padding: '1%'
        },
    },
    graphcontent: {
        width: 150,
    },
    paper: {
        height: 140,
        width: 300,
        justifyContent: 'centre'
    },
    formargin: {
        margin: '2%',
        border: '1px solid #cacaca',
        borderRadius: '10px',
        backgroundColor: '#e8e3e3'
    },
    header: {
        backgroundColor: '#7caeea',
        color: '#fff',
        [theme.breakpoints.up('xs')]: {
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }
}));

export default useStyles;